angular
    .module('app')
    .constant('buildVersion', "2026-10-15-09-32-51");
